import { render, staticRenderFns } from "./Strut1000.vue?vue&type=template&id=9800e31c"
import script from "./Strut1000.vue?vue&type=script&lang=js"
export * from "./Strut1000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports